import { baseApi } from "./baseApi";
import * as API from "@utils/apiPath";
import type { ApiResponse, FaqPayload } from "interface/faq";
import type { StatusInterface } from "interface/common";

export const faqApi = baseApi.injectEndpoints({
  endpoints: (builder) => ({
    getFaqs: builder.query<ApiResponse, { [key: string]: string | number }>({
      query: (params) => ({
        url: API.GET_FAQ,
        method: "GET",
        params,
      }),
      providesTags: ["Faq"],
    }),
    createFaq: builder.mutation<ApiResponse, FaqPayload>({
      query: ({ params }) => ({
        url: API.GET_FAQ,
        method: "POST",
        body: params,
      }),
      invalidatesTags: ["Faq"],
      async onQueryStarted(arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
          arg.onClose();
        } catch (error) {
          console.error("Failed to create FAQ:", error);
        }
      },
    }),
    updateFaq: builder.mutation<ApiResponse, FaqPayload>({
      query: ({ params }) => ({
        url: API.GET_FAQ,
        method: "PUT",
        body: params,
      }),
      invalidatesTags: ["Faq"],
      async onQueryStarted(arg, {queryFulfilled }) {
        try {
          await queryFulfilled;
          arg.onClose();
        } catch (error) {
          console.error("Failed to update FAQ:", error);
        }
      },
    }),
    updateFaqStatus: builder.mutation<ApiResponse, StatusInterface>({
      query: ({ id, ...body }) => ({
        url: `/${API.GET_FAQ}/status/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["Faq"],
      async onQueryStarted(_arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          console.error("Failed to update FAQ status:", error);
        }
      },
    }),
    deleteFaq: builder.mutation<ApiResponse, string>({
      query: (id) => ({
        url: `/${API.GET_FAQ}/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["Faq"],
      async onQueryStarted(_arg, { queryFulfilled }) {
        try {
          await queryFulfilled;
        } catch (error) {
          console.error("Failed to update FAQ status:", error);
        }
      },
    }),
    bulkUpdateFaqStatus: builder.mutation<
      ApiResponse,
      { ids: string[]; status: boolean }
    >({
      query: ({ ids, status }) => ({
        url: `/${API.GET_FAQ}/bulk-status`,
        method: "PUT",
        body: { ids, status },
      }),
      invalidatesTags: ["Faq"],
    }),
    bulkDeleteFaqs: builder.mutation<ApiResponse, { ids: string[] }>({
      query: ({ ids }) => ({
        url: `/${API.GET_FAQ}/bulk-delete`,
        method: "DELETE",
        body: { ids },
      }),
      invalidatesTags: ["Faq"],
    }),
    reorderFaqs: builder.mutation<ApiResponse, { ids: string[] }>({
      query: ({ ids }) => ({
        url: `/${API.GET_FAQ}/reorder`,
        method: "PUT",
        body: { ids },
      }),
      invalidatesTags: ["Faq"],
    }),
  }),
});

export const {
  useGetFaqsQuery,
  useCreateFaqMutation,
  useUpdateFaqMutation,
  useUpdateFaqStatusMutation,
  useDeleteFaqMutation,
  useBulkUpdateFaqStatusMutation,
  useBulkDeleteFaqsMutation,
  useReorderFaqsMutation,
} = faqApi;

